<script lang="ts">
  import { type Snippet } from "svelte";
  import { createStep, type WorkflowState } from "./workflowLib.svelte"

  let {
    path = undefined,
    disabled = false,
    oncomplete = undefined,
    state = {},
    children
  } : {
    path? : string | undefined;
    disabled? : boolean;
    oncomplete?: ()=>void;
    state?: WorkflowState;
    children : Snippet;
  } = $props()

  // svelte-ignore state_referenced_locally
  const step = createStep(path)
  $effect(() => {
    step.disabled = !!disabled
    step.oncomplete = oncomplete
    step.path = path
    step.state = state
  })
</script>
{#if step.active}
  <div style="display: {step.hidden ? 'none' : 'contents'}">
    {@render children()}
  </div>
{/if}
